import React, { useState, useEffect } from "react";
import useCeo from "../../hooks/useCEO";
import { useUnidades } from "../../hooks/test/useUnidades";
import { BuscarUnidad } from "../../components/filtros/BuscarUnidad";
import { Spinner } from "../../components/Spinner";
import Swal from "sweetalert2";

export const UnidadesAutos = () => {
    useCeo({
        title: "Lista de unidades autos",
        description: "Página de unidades autos",
    });

    const { getUnidadesTipo } = useUnidades();
    const [unidades, setUnidades]= useState([]);
    const [paginado, setPaginado]= useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        setLoading(true);
        let resp = await getUnidadesTipo(4, 1, 5);
        if (resp.ok) {
            setUnidades(resp.vehiculos);
            setPaginado(resp.paginacion);
        } 
        
        setLoading(false);
        if (!resp.ok)
        return Swal.fire({
            title: "Error",
            text: resp.msg,
            icon: "info",
        });
    };

    return (
        <>
            {loading && <Spinner />}
            <div className="container">
                <BuscarUnidad unidades={unidades} paginacion={paginado} tipoUnidades={4}/>
            </div>
        </>
    );
}